import { Spacing, Title } from '@vkontakte/vkui';
import React, { type Dispatch, type SetStateAction, memo, useCallback } from 'react';
import type { AiGenerateImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { AiImageStylesGrid } from 'reactApp/ui/AiPhotoGeneration/AiGenerationStylesPopup/AiImageStylesGrid';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';

import styles from './AiGenerationStylesPopup.css';

interface IProps {
    setSelectedStyle: Dispatch<SetStateAction<AiGenerateImageStyleType | null>>;
    onClose?: () => void;
}

export const AiGenerationStylesPopup = memo<IProps>(({ setSelectedStyle, onClose }) => {
    const onStyleClick = useCallback(
        (style: AiGenerateImageStyleType) => {
            setSelectedStyle(style);
            onClose?.();
        },
        [setSelectedStyle, onClose]
    );

    return (
        <Dialog
            open
            id="ai-generation-styles"
            onCancel={onClose}
            className={styles.modal}
            theme="dark"
            closeIconWrapperClassName={styles.closeIcon}
        >
            <div className={styles.wrapper}>
                <Title level="1">Стили</Title>
                <Spacing size={16} />
                <AiImageStylesGrid onClick={onStyleClick} />
            </div>
        </Dialog>
    );
});

export const renderAiGenerationStylesPopup = (data?: IProps) => {
    openPopupHelper({ popupName: popupNames.AI_GENERATION_STYLES, data });
};

AiGenerationStylesPopup.displayName = 'AiGenerationStylesPopup';
